import { calculateIfQuestIsCompleted } from '../../../../../utils/utilsQuests';
import { shortenText } from '../../../../../utils/utilsString';
import { QuestsSectionProps } from './props';
import RastelCoinIcon from '../../../../../assets/svg/rastel_coin.svg?react';
import { useTranslation } from 'react-i18next';

export const QuestsSection = ({
  quests,
  userCompletedQuests,
}: QuestsSectionProps) => {
  const { t } = useTranslation();
  const parkingQuestsDefined = quests.length > 0;

  if (!parkingQuestsDefined) {
    return null;
  }

  return (
    <>
      <div className="h-[0.5px] my-1" />
      <div>
        <span
          className={`${
            parkingQuestsDefined
              ? 'text-black font-bold font-mono'
              : 'text-gray-dark'
          } text-xs   `}
        >
          {parkingQuestsDefined ? t('parkingQuests') : null}
        </span>
        <div
          className={`flex w-full flex-row gap-4  overflow-y-scroll ${
            parkingQuestsDefined ? 'pb-2 mt-2' : 'pb-0'
          } `}
        >
          {quests?.map((quest) => {
            const isCompleted = calculateIfQuestIsCompleted(
              quest,
              userCompletedQuests
            );
            return (
              <div
                className={`p-3 flex-shrink-0 border border-black rounded-lg max-w-[260px] ${
                  isCompleted && 'border-green-600 border-2'
                }`}
                key={quest.id}
              >
                <div className="flex justify-between items-center gap-4">
                  <div className="text-primary font-bold flex gap-2">
                    {quest.quest.title} {isCompleted && <div>✅</div>}
                  </div>
                  <div className="text-primary font-bold flex gap-1 items-center">
                    {quest.quest.reward}x <RastelCoinIcon />
                  </div>
                </div>
                <div className="text-gray-2 text-xs w-full mt-2">
                  Description {shortenText(quest.quest.description, 30)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
